export class EventBackgroundSchedule {
  public time?: string;
  public description: string;
}
